export interface ISbpWaitSession {
  transactionId: string
  schemaPrefix?: string
  startedAt: number
}

const STORAGE_KEY = 'tapper_sbp_wait'
const TTL_MS = 30 * 60 * 1000

const canUseStorage = (): boolean =>
  typeof window !== 'undefined' && typeof sessionStorage !== 'undefined'

export const saveSbpWait = (payload: { transactionId: string; schemaPrefix?: string }): void => {
  if (!canUseStorage() || !payload.transactionId) {
    return
  }

  const session: ISbpWaitSession = {
    transactionId: String(payload.transactionId),
    schemaPrefix: payload.schemaPrefix,
    startedAt: Date.now()
  }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session))
}

export const readSbpWait = (): ISbpWaitSession | null => {
  if (!canUseStorage()) {
    return null
  }

  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return null
    }

    const session = JSON.parse(raw) as ISbpWaitSession
    if (!session?.transactionId) {
      clearSbpWait()
      return null
    }

    if (Date.now() - Number(session.startedAt) > TTL_MS) {
      clearSbpWait()
      return null
    }

    return session
  } catch {
    clearSbpWait()
    return null
  }
}

export const clearSbpWait = (): void => {
  if (!canUseStorage()) {
    return
  }
  sessionStorage.removeItem(STORAGE_KEY)
}
